<div class="RegistrationForm">
  <div class="Wrap">
    <div class="Content">
      <div class="RegistrationForm-container">
        <mat-stepper linear #stepper>
          <!-- PAGE 1 -->
          <mat-step [stepControl]="emailFormGroup" label="Email">
            <div class="row">
              <div class="col-lg-8">
                <form [formGroup]="emailFormGroup">
                  <div class="Page Page--01">
                    <header>
                      <h2>Create your Cullen International account</h2>
                        <div class="Notice">
                          Our training courses and regulatory intelligence services are predominantly designed for the use of government entities, regulators, communications service providers or manufacturers. We reserve the right to offer access to our training courses only to selected organisations. Feel free to <a href="mailto:events@cullen-international.com?subject=Am%20I%20eligible%20?">contact us</a> if you have any question regarding your eligibility.
                        </div>
                      <p>Start creating your Cullen International account by entering your professional email address.</p>
                    </header>
                    <div class="Alert" *ngIf="emailAlreadyExists">
                      <!-- An account with same email exists. Please <a (click)="login()">login</a> or try to <a href="{{getResetPasswordUrl()}}">reset your password</a>. -->
                      An account with same email exists, please <a (click)="login()">login</a>.
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <h3>Enter your professional e-mail</h3>
                        <mat-form-field class="FormElement">
                          <mat-label data-cy="label">professional e-mail</mat-label>
                          <input data-cy="email" name="email" matInput formControlName="emailCtrl" type="email" autocomplete="email" required [ngClass]="{ 'is-invalid': fEmail.emailCtrl.touched && fEmail.emailCtrl.errors }">
                          <div *ngIf="fEmail.emailCtrl.touched && fEmail.emailCtrl.errors" class="invalid-feedback">
                            <div *ngIf="fEmail.emailCtrl.errors.required">Email is required</div>
                            <div *ngIf="fEmail.emailCtrl.errors.email">Email must be a valid email address</div>
                          </div>
                        </mat-form-field>
                      </div>
                    </div>
                    <footer>
                      <button class="Button Button--next" mat-button data-cy="validateEmailButton" (click)="validateEmailAndForwardToPersonalDetails(stepper)">Next</button>
                      <p><span>Already have an account? </span><a (click)="login()">Please log in</a></p>
                    </footer>
                  </div>
                  <legend>* Mandatory fields</legend>
                </form>
              </div>
              <div class="col-lg-4">
                <div class="Login">
                  <h2>Already have an account</h2>
                  <p>If you already have a Cullen account, you can go to our login page.</p>
                  <button class="Button" (click)="login()">Log in</button>
                </div>
              </div>
            </div>
          </mat-step>
          <!-- PAGE 2 -->
          <mat-step  [stepControl]="personalDetailsFormGroup" label="Personal Details">
            <form [formGroup]="personalDetailsFormGroup">
              <div class="Page Page--02">
                <h3>Enter your personal details</h3>
                <div class="row">
                  <div class="col-md-6">
                    <mat-form-field class="FormElement">
                      <mat-label>First name</mat-label>
                      <input data-cy="firstName" name="fname" matInput type="text" formControlName="firstNameCtrl"  autocomplete="given-name" required>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field class="FormElement">
                      <mat-label>Last name</mat-label>
                      <input data-cy="lastName" name="lname" matInput type="text" formControlName="lastNameCtrl" autocomplete="family-name" required>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <mat-form-field class="FormElement">
                      <mat-label>Phone number</mat-label>
                      <input data-cy="phoneNumber" name="phone" matInput type="text" formControlName="phoneNumberCtrl"  autocomplete="tel">
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance="fill" class="FormElement" *ngIf="countries$ | async as countries">
                      <mat-label>Country</mat-label>
                      <mat-select data-cy="country" formControlName="countryCtrl" required >
                        <mat-option *ngFor="let country of countries" [value]="country.code">
                          {{country.name}}
                        </mat-option>
                      </mat-select>
                  </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <mat-form-field class="FormElement">
                      <mat-label>Organisation name</mat-label>
                      <input data-cy="organisationName" name="organization" matInput type="text" formControlName="organisationNameCtrl"  autocomplete="organization" required>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance="fill" class="FormElement">
                      <mat-label>Organisation type</mat-label>
                      <mat-select data-cy="organisationType" formControlName="organisationTypeCtrl" required>
                        <mat-option value="Academic">Academic</mat-option>
                        <mat-option value="Association">Association</mat-option>
                        <mat-option value="Broadcaster">Broadcaster</mat-option>
                        <mat-option value="Competition_Authority">Competition Authority</mat-option>
                        <mat-option value="Consultant">Consultant</mat-option>
                        <mat-option value="Consumer_Authority">Consumer Authority</mat-option>
                        <mat-option value="Data_Protection_Authority">Data Protection Authority</mat-option>
                        <mat-option value="EU_Institution">EU Institution</mat-option>
                        <mat-option value="Law_Firm">Law Firm</mat-option>
                        <mat-option value="Manufacturer">Manufacturer</mat-option>
                        <mat-option value="Ministry_Government">Ministry Government</mat-option>
                        <mat-option value="Online_service_provider">Online service provider</mat-option>
                        <mat-option value="Parcel_Courrier">Parcel Courrier</mat-option>
                        <mat-option value="Postal_Operator">Postal Operator</mat-option>
                        <mat-option value="Regulator">Regulator</mat-option>
                        <mat-option value="Satellite_Operator">Satellite Operator</mat-option>
                        <mat-option value="Spectrum_Authority">Spectrum Authority </mat-option>
                        <mat-option value="Telecoms_Operator">Telecoms Operator</mat-option>
                        <mat-option value="Other">Other</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <mat-form-field appearance="fill" class="FormElement">
                      <mat-label>Job title</mat-label>
                      <mat-select data-cy="jobTitle" formControlName="jobTitleCtrl" required>
                        <mat-option value="Analyst">Analyst</mat-option>
                        <mat-option value="C_Level">C Level</mat-option>
                        <mat-option value="Director">Director</mat-option>
                        <mat-option value="Expert">Expert</mat-option>
                        <mat-option value="Manager">Manager</mat-option>
                        <mat-option value="Officer">Officer</mat-option>
                        <mat-option value="Operations">Operations</mat-option>
                        <mat-option value="President">President</mat-option>
                        <mat-option value="Project_Management">Project Management</mat-option>
                        <mat-option value="Sales_and_Marketing">Sales and Marketing</mat-option>
                        <mat-option value="Specialist">Specialist</mat-option>
                        <mat-option value="Teaching">Teaching</mat-option>
                        <mat-option value="Technical_Specialist">Technical Specialist</mat-option>
                        <mat-option value="VP">VP</mat-option>
                      </mat-select>
                  </mat-form-field>
                  </div>
                </div>
                <footer>
                  <button class="Button Button--back Button--white" data-cy="backToEmailButton" mat-button matStepperPrevious>Back</button>
                  <button class="Button Button--next" data-cy="nextToPasswordButton" mat-button (click)="nextToPasswordButton(stepper)">Next</button>
                </footer>
              </div>
              <legend>* Mandatory fields</legend>
            </form>
          </mat-step>
          <!-- PAGE 3 -->
          <mat-step [stepControl]="passwordFormGroup" label="Password">
            <form [formGroup]="passwordFormGroup">
              <input name="disable-pwd-mgr-1" type="password" id="disable-pwd-mgr-1" style="display: none;" value="disable-pwd-mgr-1" />
              <input name="disable-pwd-mgr-2" type="password" id="disable-pwd-mgr-2" style="display: none;" value="disable-pwd-mgr-2" />
              <input name="disable-pwd-mgr-3" type="password" id="disable-pwd-mgr-3" style="display: none;" value="disable-pwd-mgr-3" />
              <div class="Page Page--03">
                <section>
                  <h3>Create your password</h3>
                  <div class="row">
                    <div class="col-md-6">
                      <mat-form-field class="FormElement NoMargin">
                        <mat-label>Password</mat-label>
                        <input data-cy="password" matInput type="password" autocomplete="false" required formControlName="passwordCtrl" [ngClass]="{ 'is-invalid': finalFormsubmitted && fPass.passwordCtrl.errors }">
                        <div *ngIf="finalFormsubmitted && fPass.passwordCtrl.errors" class="invalid-feedback">
                          <div *ngIf="fPass.passwordCtrl.errors.required">Mandatory field</div>
                          <div *ngIf="fPass.passwordCtrl.errors.minlength">Password must be at least 8 characters</div>
                        </div>
                      </mat-form-field>
                    </div>
                    <div class="col-md-6">
                      <mat-form-field class="FormElement NoMargin">
                        <mat-label>Confirm password</mat-label>
                        <input data-cy="confirmPassword" matInput type="password" autocomplete="false" required formControlName="confirmPasswordCtrl" [ngClass]="{ 'is-invalid': finalFormsubmitted && fPass.confirmPasswordCtrl.errors }">
                        <div *ngIf="finalFormsubmitted && fPass.confirmPasswordCtrl.errors" class="invalid-feedback">
                          <div *ngIf="fPass.confirmPasswordCtrl.errors.required">Mandatory field</div>
                          <div *ngIf="fPass.confirmPasswordCtrl.errors.mustMatch">Passwords must match</div>
                        </div>
                      </mat-form-field>
                    </div>
                  </div>
                  <p class="Info">Use at least eight characters</p>
                </section>
                <section>
                  <h3>Privacy Policy</h3>
                  <div class="FormElement">
                    <div class="CustomCheckbox">
                      <input data-cy="privacy" type="checkbox" id="privacy" required name="privacy" formControlName="privacyCtrl" [ngClass]="{ 'is-invalid': finalFormsubmitted && fPass.privacyCtrl.errors }"/>
                      <label for="privacy">I have read and accept the <a href="https://www.cullen-international.com/privacy.html">Privacy policy</a>. *</label>
                      <div *ngIf="finalFormsubmitted && fPass.privacyCtrl.errors" class="invalid-feedback">Accept Privacy Policy is required</div>
                    </div>
                    <div class="CustomCheckbox">
                      <input data-cy="newsletterOptIn" type="checkbox" id="newsletterOptIn"  name="newsletterOptIn" formControlName="newsletterOptInCtrl" />
                      <label for="newsletterOptIn">Yes, keep me informed about Cullen International's latest research and services. You can unsubscribe at any time.</label>
                    </div>
                  </div>
                 </section>
                <footer>
                  <button class="Button Button--back Button--white" mat-button data-cy="backToPersonalDetailButton" (click)="backToPersonalDetails(stepper)">Back</button>
                  <button class="Button Button--signup" mat-button data-cy="nextToRegisterButton" (click)="registerUser(stepper)">Create account</button>
                </footer>
              </div>
              <legend>* Mandatory fields</legend>
            </form>
          </mat-step>
          <!-- PAGE 4 -->
          <mat-step label="Confirmation">
            <div class="Page Page--04">
              <div *ngIf="accountSuccess" data-cy="successUser">
                <h2>Thank you</h2>
                <p>Your account is now created. To continue with your registration, please follow these steps:</p>
                <ul class="List">
                  <li>Check your mailbox. We have sent you an email to activate your account.</li>
                  <li>Click on “<b>Activate your account</b>”.</li>
                  <li>Continue with your training registration. </li>
                </ul>
                <p>If you have any problem, please <a href="https://www.cullen-international.com/contact.html#form" target="secondaryTab">contact us</a>.</p>
              </div>
              <div *ngIf="!accountSuccess" data-cy="failUser">
                <h2>There was an error in creating your account</h2>
                <p>Please try again or contact our <a href="mailto:helpdesk@cullen-international.com?Subject=Help Self Registration">helpdesk</a> if the problem persists.</p>
                <footer>
                  <button class="Button" data-cy="resetButton" mat-button (click)="stepper.reset()">Reset</button>
                </footer>
              </div>
            </div>
          </mat-step>
        </mat-stepper>
      </div>
    </div>
  </div>
</div>

